import { takeLatest, put } from 'redux-saga/effects';
import { forceReload as forceReloadUserList } from '~/components/containers/UserManagementContainer/reducer';
import callRequestSaga from '~/sagas/utils/request-saga';
import { EditUserContainerConstants } from '~/components/containers/EditUserContainer/constants';
import UserManagementSubmenuConstants from '~/components/containers/UserManagementSubmenuContainer/constants';
import type {
  EditUserRequestAction,
  GetUserAction,
} from '~/components/containers/EditUserContainer/types/actions.types';
import UserManagementAPI from '~/api/user-management-api';
import BaseException from '~/utils/fetch-wrapper/errors/BaseException';

export function* getUser({ payload }: GetUserAction) {
  yield* callRequestSaga(
    UserManagementAPI.getUser,
    {
      request: EditUserContainerConstants.GET_USER_REQUEST,
      success: EditUserContainerConstants.GET_USER_REQUEST_SUCCESS,
      failure: EditUserContainerConstants.GET_USER_REQUEST_ERROR,
      payload,
    },
    payload.userId
  );
}

export function* editUser({ payload }: EditUserRequestAction) {
  const response = yield* callRequestSaga(
    UserManagementAPI.editUser,
    {
      request: EditUserContainerConstants.EDIT_USER_REQUEST,
      success: EditUserContainerConstants.EDIT_USER_REQUEST_SUCCESS,
      failure: EditUserContainerConstants.EDIT_USER_REQUEST_ERROR,
      payload,
    },
    payload.userId,
    payload.roles
  );

  if (response instanceof BaseException) {
    return;
  }

  //Force update on next page load of user/invite list
  yield put(forceReloadUserList());

  //Reload submenu
  yield put({
    type: UserManagementSubmenuConstants.GET_USER_MANAGEMENT_SUBMENU,
  });

  //Close edit user modal
  yield put({ type: EditUserContainerConstants.CLOSE_EDIT_USER_MODAL });
}

export function* editUserSaga() {
  yield takeLatest(EditUserContainerConstants.EDIT_USER as any, editUser);
}

export function* getUserSaga() {
  yield takeLatest(EditUserContainerConstants.GET_USER as any, getUser);
}

export default [editUserSaga, getUserSaga];
